import type { PlanTier } from '@frameio/graphql-client/generated';
import { TIER_MAP } from './useNextTierPlan';

export const getMemberSeatSubscriptionCost = ({
  isFreeTierPlan,
  planCost,
  planUserLimit,
  userLimitAddOnCost,
}: {
  isFreeTierPlan?: boolean;
  planCost?: number | null;
  planUserLimit?: number | null;
  userLimitAddOnCost?: number | null;
}) => {
  if (isFreeTierPlan) return 0;

  const perSeatCostFromPlan =
    planCost != null && planUserLimit ? planCost / planUserLimit : 0;

  return userLimitAddOnCost ?? perSeatCostFromPlan;
};

export const getIncludedMemberSeatsAvailable = ({
  planUserLimit,
  seatsUsed,
}: {
  planUserLimit?: number | null;
  seatsUsed?: number | null;
}) =>
  planUserLimit != null && seatsUsed != null
    ? Math.max(planUserLimit - seatsUsed, 0)
    : Infinity;

export const isMemberSeatUpgradeAllowed = ({
  tier,
}: {
  tier?: PlanTier | null;
}) => {
  const nextTier = tier ? TIER_MAP[tier] : '';
  return Boolean(nextTier) && nextTier !== tier;
};
